import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';

/**
 * `ui:field: BobbeeBranchPicker`: picks the developer's app-bobbee branch that a golden-path
 * template opens its scaffolding PR against (templates/, docs/golden-paths.md).
 */
const bobbeeBranchPickerField = FormFieldBlueprint.make({
  name: 'bobbee-branch-picker',
  params: {
    field: async () => {
      const { BobbeeBranchPicker, validateBranchTarget } = await import(
        './BobbeeBranchPicker'
      );
      return createFormField({
        name: 'BobbeeBranchPicker',
        component: BobbeeBranchPicker,
        validation: validateBranchTarget,
      });
    },
  },
});

export const scaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [bobbeeBranchPickerField],
});
